import { render, staticRenderFns } from "./savedInvoice.vue?vue&type=template&id=9febf384&scoped=true"
import script from "./savedInvoice.vue?vue&type=script&lang=js"
export * from "./savedInvoice.vue?vue&type=script&lang=js"
import style0 from "./savedInvoice.vue?vue&type=style&index=0&id=9febf384&prod&lang=scss"
import style1 from "./savedInvoice.vue?vue&type=style&index=1&id=9febf384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9febf384",
  null
  
)

export default component.exports